<template lang="pug">
  svg.svg-oven(:x="x" :y="y" width="325" height="325" viewBox="0 0 325 325" preserveAspectRatio="xMidYMid meet")
    title Oven
    rect.oven-cls-1(x="0.5" y="12.5" width="324" height="58")
    g(v-if="!hideControl")
      title Oven Control
      rect.oven-cls-2(x="45" y="21" width="233" height="40" rx="4")
      text.oven-text-1(x="55" y="50" text-anchor="start") {{ temperature }}
      text.oven-text-1(x="270" y="50" text-anchor="end") {{ time }}
    rect.oven-cls-1(x="0.5"  y="70"  width="324" height="230")
    rect.oven-cls-2(x="45" y="128" width="233" height="140" rx="4")
    polygon.oven-cls-3(points="20 90 315 90 315 110 20 110 20 90")
    polygon.oven-cls-4(points="20 90 315 90 305  85 15  85 20 90")
    polygon.oven-cls-5(points="15 85  20 90  20 110 15 105 15 85")
    rect.oven-cls-3(x="0.5" y="300" width="324" height="24")
</template>

<script>
export default {
  name: 'svg-oven',

  props: {
    x: Number,
    y: Number,
    hideControl: Boolean,
    temperature: String,
    time: String,
  },

};
</script>

<style lang="scss" scoped>
.svg-oven {

  .oven-cls-1 {
    fill: var(--fill-color-1, #ccc);
    stroke: var(--stroke-color-1, #000);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 10;
    vector-effect: non-scaling-stroke;
  }
  .oven-cls-2 {
    fill: var(--fill-color-2, #1a1a1a);
    stroke: var(--stroke-color-2, none);
    stroke-width: var(--stroke-width-2, 1px);
    stroke-miterlimit: 4;
    vector-effect: non-scaling-stroke;
  }
  .oven-cls-3 {
    fill: var(--fill-color-3, #999);
    stroke: var(--stroke-color-3, #000);
    stroke-width: var(--stroke-width-3, 1px);
    stroke-miterlimit: 2;
    vector-effect: non-scaling-stroke;
  }
  .oven-cls-4 {
    fill: var(--fill-color-4, #595959);
    stroke: var(--stroke-color-4, #000);
    stroke-width: var(--stroke-width-4, 1px);
    stroke-miterlimit: 2;
    vector-effect: non-scaling-stroke;
  }
  .oven-cls-5 {
    fill: var(--fill-color-5, #333);
    stroke: var(--stroke-color-5, #000);
    stroke-width: var(--stroke-width-5, 1px);
    stroke-miterlimit: 2;
    vector-effect: non-scaling-stroke;
  }

  .oven-text-1 {
    fill: #39B54A;
    font-family: monospace;
    font-size: 32px;

    -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
       -khtml-user-select: none; /* Konqueror HTML */
         -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
              user-select: none;
  }
}
</style>
